const routes: any = [
    {
        name: "Axxess Connect",
        path: "/central-messaging/clinicians/conversation",
        meta: {
            menuName: "Axxess Connect",
            navItem: "tabMessaging",
            showAxxessConnect: true
        }
    },
    {
        name: "Axxess Home",
        path: "/help",
        meta: {
            menuName: "Axxess Home",
            navItem: "tabHelp"
        }
    }
];

export default routes;
